export const NMLS_RECERT_LABEL = 'NMLS recert';

export const LICENSE_EXPIRED_TITLE = `${NMLS_RECERT_LABEL} · expired`;
export const LICENSE_NO_LICENSE_TITLE = 'No license on file';
export const LICENSE_RECERT_BY_PREFIX = 'Recert by';

// The license records expose the expiry on either `expirationDate` (account model)
// or `licenseExpireDate` (the shared LicensedStatesTable shape); read both.
export const LICENSE_EXPIRATION_FIELDS = ['expirationDate', 'licenseExpireDate'];

export const COMPLIANCE_CREDENTIAL_NOT_TRACKED = 'Not tracked';

// E&O and CE recert have no real source yet (net-new Accounts schema, separate
// epic). They render an explicit "not tracked" state rather than a fake countdown.
export const COMPLIANCE_CREDENTIALS = [
  { id: 'credential-e-and-o', label: 'E&O coverage' },
  { id: 'credential-ce', label: 'CE recert' },
];
